exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".content-ed26668b{padding:15px 0px}.createdAt-363f291c{font-size:13px;color:#616161;line-height:20px}\n", ""]);

// Exports
exports.locals = {
	"content": "content-ed26668b",
	"createdAt": "createdAt-363f291c"
};